var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Poptip',{staticClass:"popper-star",attrs:{"trigger":"hover"}},[_c('div',{attrs:{"slot":"content"},slot:"content"},[_c('div',{staticClass:"task-wrap-all"})])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }